module.exports = __webpack_public_path__ + "4879d365faaae9a0380564313cc5bc21.png";